import {getCurrentYear} from '../../utils/commons'
import OfficeGearPicksLogo from './logo'
import {officeGearPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'officegearpicks' as const,
  domainType: 'picks' as const,
  camelCaseUrl: 'OfficeGearPicks.com',
  siteName: 'Office Gear Picks',
  logo: <OfficeGearPicksLogo className="size-9 shrink-0 tablet:size-6" />,
  favicon: '/favicons/officegearpicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-MKZ8RSJZVQ',
    title: (category: string, _count: string) =>
      `${category} Reviewed | Best Products of ${getCurrentYear()} | OfficeGearPicks.com`,
    description: (_category?: string, _count?: string) =>
      `OfficeGearPicks.com simplifies choosing reliable office gear. Our expert-driven reviews and comprehensive product comparisons help you select trusted supplies for productivity and comfort.`,
    styles: officeGearPicksStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
